<template>
  <v-form v-model="formValid">
    <v-subheader class="font-italic font-weight-light py-1">Generale</v-subheader>
    <v-row no-gutters class="py-1">
      <v-col>
        <v-text-field
          v-model="name"
          :rules="[max255CharRule, presenceRule]"
          dense
          filled
          label="Nome"
          hide-details="auto"
        ></v-text-field>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import Vue from 'vue'
import jobForm from '@/services/jobs/job.form.js'

export default {
  name: "GeneralFormTab",
  components: {},
  data: function() {
    return {
      name: undefined,
      description: undefined,
      loadingJob: false,
      formValid: false,
      max255CharRule: (v) => {
        if(v) {
          return v.length <= 255 || 'Al massimo 255 caratteri'
        } else {
          return true
        }
      },
      presenceRule: (v) => {
        return !!v || 'Il campo è obbligatorio'
      },
    };
  },
  props: {
    bus: {
      type: Object,
      default: function() {
        return new Vue()
      }
    }
  },
  mounted: function() {
    this.handleObjectChanges(jobForm.job)

    var self = this
    jobForm.on('update', function(data) {
      self.handleObjectChanges(data.job)
    })
  },
  methods: {
    fields() {
      return ['name', 'description']
    },
    handleObjectChanges(job) {
      const fields = this.fields()
      const newValKeys = Object.keys(job)

      for(let i = 0; i < fields.length; i++) {
        const field = fields[i]
        if(newValKeys.includes(field) && job[field] != this[field]) {
          this[field] = job[field]
        }
      }
    },
  },
  watch: {
    formValid(newVal) {
      this.$emit('update:valid', newVal)
      if(this.bus) {
        this.bus.$emit('update:valid', newVal)
      }
      jobForm.setValid(newVal)
    },
    name(newVal) {
      jobForm.updateField('name', newVal)
    },
    description(newVal) {
      jobForm.updateField('description', newVal)
    },
  }
};
</script>